export default function ConfigMissing() {
  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-3"
      style={{ background: 'var(--bb-bg)' }}
    >
      <div className="card shadow-sm" style={{ maxWidth: 520, width: '100%' }}>
        <div className="card-body p-4">
          <h1 className="h5 text-danger mb-3">Configuração do Supabase ausente</h1>
          <p className="small text-muted">
            O painel precisa das variáveis <code>VITE_SUPABASE_URL</code> e{' '}
            <code>VITE_SUPABASE_ANON_KEY</code> para carregar a tela de login.
          </p>
          <p className="small fw-semibold mb-2">Opção A — usar o switch central (recomendado)</p>
          <pre className="bg-light p-3 rounded small mb-3">{`# Na raiz do repo:
SUPABASE_TARGET=local

# Depois reinicie:
cd apps/web
npm run dev`}</pre>
          <p className="small fw-semibold mb-2">Opção B — exemplo</p>
          <pre className="bg-light p-3 rounded small mb-0">{`cp .env.example .env
# Cole a anon key do Supabase (Dashboard → API)`}</pre>
          <p className="small text-muted mt-3 mb-0">
            Depois: <code>npm run dev</code> e abra{' '}
            <a href="http://localhost:5175">http://localhost:5175</a>
          </p>
        </div>
      </div>
    </div>
  );
}
